import React from 'react'
import get from 'lodash/get'
import ActualEfficiency from './actual-efficiency'
import ResourceTable from './resource-table'

export default class Content extends React.Component {
  render() {
    const submitTab = get(this.props, 'submitTab')
    switch (submitTab) {
      case 1: return (
        <ActualEfficiency
          efficiencyResource={ get(this.props, 'efficiencyResource') }
          editEfficiency={ get(this.props, 'editEfficiency') }
        />
      )
      case 2: return (
        <ResourceTable
          searchResource={ get(this.props, 'searchResource') }
          efficiencyResource={ get(this.props, 'efficiencyResource') }
        />
      )
      default: return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/tab-content/index.js